import { ArrowRight, Check, Mail, ShieldCheck } from 'lucide-react'
import { Link } from 'react-router-dom'

export function IntegrationsPublic(){return <>
  <section className="public-page-hero public-container">
    <span className="public-kicker">Integrations</span>
    <h1>Connect Gmail or Outlook once. Keep working in the inbox you already use.</h1>
    <p>
      Mail Percent uses provider OAuth. Managers can connect their own or shared team mailboxes, while invited employees connect their own work inbox from the Employee Workspace.
    </p>
  </section>

  <section className="public-section public-container">
    <div className="integration-public-grid">
      <article>
        <div className="provider-big google"><img src="/images/integrations/gmail-logo.png" alt="Gmail" /></div>
        <div>
          <span className="public-kicker">Google</span>
          <h2>Gmail</h2>
          <p>Employees approve Gmail access when they connect their work inbox. Mail Percent then uses the Gmail API for the operational metadata required by the workspace.</p>
          <ul>
            <li><Check/>One-time OAuth connection</li>
            <li><Check/>Gmail API measurement</li>
            <li><Check/>Employee-controlled personal inbox access</li>
            <li><Check/>No browser extension required</li>
          </ul>
        </div>
      </article>

      <article>
        <div className="provider-big microsoft"><img src="/images/integrations/outlook-logo.png" alt="Microsoft Outlook" /></div>
        <div>
          <span className="public-kicker">Microsoft</span>
          <h2>Outlook</h2>
          <p>Employees connect Microsoft 365 or Outlook through Microsoft OAuth. Shared team inboxes can be connected by an authorised manager and assigned to the people who work from them.</p>
          <ul>
            <li><Check/>One-time Microsoft authorization</li>
            <li><Check/>Microsoft Graph API access</li>
            <li><Check/>Employee invitation workflow</li>
            <li><Check/>Works without browser monitoring</li>
          </ul>
        </div>
      </article>
    </div>
  </section>

  <section className="public-section public-soft-section">
    <div className="public-container public-split-section light">
      <div>
        <ShieldCheck className="section-icon"/>
        <span className="public-kicker">Architecture</span>
        <h2>Get the accountability signals without moving customer conversations into Mail Percent.</h2>
        <p>Mail Percent is designed around provider metadata and timestamps. Core records do not need message bodies, snippets or attachments to calculate response, queue, workload and SLA Performance metrics.</p>
        <Link to="/security" className="button ghost public-cta">Security & privacy <ArrowRight size={15}/></Link>
      </div>

      <div className="content-boundary-card">
        <small>Mail provider</small>
        <div><Mail/><span>Customer message content</span><b>Stays here</b></div>
        <i/>
        <small>Mail Percent</small>
        <div><Check/><span>Email conversation reference</span><b>Operational</b></div>
        <div><Check/><span>Arrival & reply timestamps</span><b>Operational</b></div>
        <div><Check/><span>Queue & SLA calculations</span><b>Operational</b></div>
      </div>
    </div>
  </section>
</>}
